module.exports = __webpack_public_path__ + "static/img/6.67fc392.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue12/04/6.jpeg
// module id = 9olZ
// module chunks = 7